import { NodeForm } from '@/components/nodes/NodeForm'
import { type ProjectFormData } from '@/lib/validations/project'
import type { Workspace, User } from '@/types'
import { nodeFormConfigs } from '@/lib/config/node-form-configs'

interface ProjectFormProps {
  mode?: 'create' | 'edit'
  defaultValues?: Partial<ProjectFormData>
  workspaces: Workspace[]
  availableUsers: User[]
  selectedUsers?: User[]
  onSubmit: (data: ProjectFormData) => Promise<void>
  onCancel: () => void
  submitText: string
  cancelText?: string
  loading?: boolean
  title: string
  description: string
  onDirtyChange?: (isDirty: boolean) => void
  simplified?: boolean // Hide workspace selector and status for onboarding
}

export function ProjectForm({
  mode = 'create',
  defaultValues,
  selectedUsers = [],
  onSubmit,
  onCancel,
  submitText,
  cancelText,
  loading = false,
  title,
  description,
  onDirtyChange,
  simplified = false,
}: ProjectFormProps) {
  const handleSubmit = async (data: Record<string, unknown>) => {
    await onSubmit(data as unknown as ProjectFormData)
  }

  const config = simplified ? nodeFormConfigs.simplified : nodeFormConfigs.project

  return (
    <NodeForm
      mode={mode}
      config={config}
      initialData={defaultValues}
      initialUsers={selectedUsers}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      submitText={submitText}
      cancelText={cancelText}
      loading={loading}
      title={title}
      description={description}
      onDirtyChange={onDirtyChange}
      simplified={simplified}
    />
  )
}
